import { render, staticRenderFns } from "./form-address.vue?vue&type=template&id=ae5662c2"
import script from "./form-address.vue?vue&type=script&lang=js"
export * from "./form-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports